import { render, staticRenderFns } from "./CBtnAccionForm.vue?vue&type=template&id=2407156a&"
import script from "./CBtnAccionForm.vue?vue&type=script&lang=js&"
export * from "./CBtnAccionForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports